import React from 'react';

const AboutUsPage: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8 min-h-screen">
      <h1 className="text-4xl font-extrabold text-amber-800 mb-6 border-b pb-2 font-[Cinzel]">
        Our Story: About Sardar Jewellers
      </h1>

      <div className="flex flex-col md:flex-row gap-10 items-start">
        {/* Left: Text Content - pehle vala saara details */}
        <div className="md:w-3/5 space-y-6 text-gray-700">
          <p className="text-lg font-semibold text-gray-800">
            Crafting legacies since 2010.
          </p>
          <p>
            <span className="text-amber-800 font-bold">Sardar Jewellers</span> was founded with a vision to bring quality, trust, and exceptional craftsmanship to every piece of jewelry we create. Located in the heart of "Kalyanpur,"" we pride ourselves on being a trusted name for gold and diamond jewelry. Since our founding, we have grown into a significant destination for discerning patrons across India, known for our robust online presence and expansive footprint.
          </p>

          <h2 className="text-2xl font-semibold text-amber-700 mt-6">
            Our Heritage and Craftsmanship
          </h2>
          <p>
            We take deep pride in our commitment to rare and traditional art, crafts and narratives, creating contemporary accessories for its discerning patrons. Every piece of jewelry at <span className="text-amber-800 font-bold">Sardar Jewellers</span> is a creation of passion, flawlessly crafted at affordable luxury price points—a feat that remains unmatched in the industry. Our collections are designed by some of the finest designers and brought to life by skilled artisans who hand-finish each piece.
          </p>
          <p>
            The only brand with a versatile line of jewellery, perfect sartorial companions to every woman and man. <span className="text-amber-800 font-bold">Sardar Jewellers</span> features jewellery for those who know their style from fashion fads and are willing to spark a trend rather than just follow it. Not just the exquisite jewellery, the prices too will add a sparkle to your smile.
          </p>
        </div>

        {/* Right: Image Section - ak main ho or uske side me half image uske uper */}
        <div className="md:w-2/5 flex gap-4">
          
          {/* Main Image (ak main ho) - Taller */}
          <div className="w-1/2 relative h-96 bg-gray-200 overflow-hidden shadow-lg rounded-lg">
              <div className="flex items-center justify-center w-full h-full text-gray-500 font-bold">
                 <img src="https://i.pinimg.com/736x/97/55/f4/9755f44fb2a9264928151e192d80e6b8.jpg" alt="About Us Main" className="object-cover w-full h-full"/>
              </div>
          </div>
          
          {/* Half Image on top (uske side me half image uske uper) */}
          <div className="w-1/2 flex flex-col gap-4">
              <div className="relative h-44 bg-gray-300 overflow-hidden shadow-lg rounded-lg">
                  <div className="flex items-center justify-center w-full h-full text-gray-500 font-bold">
                      <img src="https://www.shutterstock.com/image-photo/guwahatiindia10-november-2023-woman-tries-600nw-2389174341.jpg" alt="About Us Top" className="object-cover w-full h-full"/>
                  </div>
              </div>
              {/* Space for visual balance or a smaller third element */}
              <div className="relative h-72 bg-gray-300 overflow-hidden shadow-lg rounded-lg">
                  <div className="flex items-center justify-center w-full h-full text-gray-500 font-bold">
                      <img src="https://i.pinimg.com/474x/69/7a/d6/697ad602b849bbfc7a7fc5fdd1cbdd2c.jpg" alt="About Us Bottom" className="object-cover w-full h-full"/>
                  </div>
              </div>
          </div>
        </div>
      </div>

      <div className="max-w-8xl mx-auto py-12 px-2 sm:px-6 lg:px-4 min-h-screen">
      <h1 className="text-4xl font-extrabold text-amber-800 mb-6 border-b pb-2 font-[Cinzel]">
        About Sardar Jewellers
      </h1>
      
      <div className="space-y-6 text-gray-700">
        <p className="text-lg font-semibold text-gray-800">
          Crafting legacies since 2010.
        </p>

        <p>
          Sardar Jewellers was founded with a vision to bring quality, trust, and exceptional craftsmanship to every piece of jewelry we create. Located in the heart of "Kalyanpur", we pride ourselves on being a trusted name for gold and diamond jewelry. Since our founding, we have grown into a significant destination for discerning patrons across India, known for our robust online presence and expansive footprint.
        </p>

        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Our Heritage and Craftsmanship
        </h2>
        <p>
          We take deep pride in our commitment to rare and traditional art, crafts, and narratives. Every piece of jewelry at Sardar Jewellers is a creation of passion, flawlessly crafted at affordable luxury price points—a feat that remains unmatched in the industry. Our collections are designed by some of the finest designers and brought to life by skilled artisans who hand-finish each piece.
        </p>
        <p>
          From classic wedding sets to contemporary daily wear, we specialize in a versatile line of jewelry, including **Necklaces, Earrings, Bangles, Pendants, Rings, and more**. Our designs cater to every woman and man who appreciate style, tradition, and quality.
        </p>
        
        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          Our Core Values
        </h2>
        <ul className="list-disc list-inside ml-4 space-y-2">
          <li>Purity : Guaranteed **BIS Hallmark** gold, ensuring the highest standards of quality and trust in your investment.</li>
          <li>Trust : Transparent pricing and policies** with full disclosure on metal weight, diamond clarity, and stone carats.</li>
          <li>Craftsmanship : Hand-finished designs by **skilled artisans**, ensuring attention to detail and lasting beauty in every piece.</li>
          <li>Accessibility : Bringing affordable luxury and unique artistic jewelry from top designers directly to your fingertips.</li>
        </ul>
        
        <h2 className="text-2xl font-semibold text-amber-700 mt-6">
          A Sparkle for Every Occasion
        </h2>
        <p>
          We believe that jewelry is more than just an accessory; it’s an emotional milestone, a celebration of life's significant moments. Sardar Jewellers features collections for those who know their style and are willing to spark a trend rather than just follow it. Not only will our exquisite jewellery add a sparkle to your look, but the prices too will add a smile to your face.
        </p>
      </div>
    </div>

    </div>
  );
};

export default AboutUsPage;